// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__3_BxO","img":"style_img__2H_8G"};